// Live search suggestions in the header (SearchBox.vue) and the command
// palette (CommandPalette.vue).
export default {
  en: {
    seeAll: 'See all results for “{query}”',
    noResults: 'Nothing found for “{query}”. Try another title or platform.',
    palette: {
      open: 'Open quick search',
      title: 'Quick search',
      placeholder: 'Search games or jump to a page…',
      results: 'Results',
      recent: 'Recent searches',
      viewed: 'Recently viewed',
      trending: 'Trending',
      goTo: 'Go to',
      removeRecent: 'Remove “{query}” from recent searches',
      hintNavigate: 'navigate',
      hintOpen: 'open',
      hintClose: 'close',
    },
  },
  cs: {
    seeAll: 'Všechny výsledky pro „{query}“',
    noResults: 'Pro „{query}“ nic nenalezeno. Zkuste jiný název nebo platformu.',
    palette: {
      open: 'Otevřít rychlé hledání',
      title: 'Rychlé hledání',
      placeholder: 'Hledejte hry nebo přejděte na stránku…',
      results: 'Výsledky',
      recent: 'Nedávná hledání',
      viewed: 'Naposledy zobrazené',
      trending: 'Populární',
      goTo: 'Přejít na',
      removeRecent: 'Odebrat „{query}“ z nedávných hledání',
      hintNavigate: 'pohyb',
      hintOpen: 'otevřít',
      hintClose: 'zavřít',
    },
  },
};
